import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setCategoryData, setCategoryDeptCol, showProgress } from '../../../redux/actions/DealershipActions';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';

const useCategory = () => {
  const dispatch = useDispatch();

  const [error, setError] = useState(null);

  const fetchCollectionsByDept = useCallback(
    async (partnerId) => {
      dispatch(showProgress(true));
      const payload = {
        rockedNetworkPartnerId: partnerId,
      };
      try {
        const response = await service.post(apiEndpoints.CAT_COLLECTION_BY_DEPT, payload);
        dispatch(setCategoryDeptCol(response, partnerId));
      } catch (err) {
        setError(err);
        dispatch(showProgress(false));
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  const fetchPartnerTypes = useCallback(
    async (selectedId) => {
      dispatch(showProgress(true));
      try {
        const response = await service.get(apiEndpoints.CAT_FETCH);
        if (response.partners && response.partners[0]?.id && !selectedId) {
          const rockEdId = response?.partners?.find((item) => item?.title === 'RockED')?.id;
          dispatch(setCategoryData(response.partners, rockEdId));
          fetchCollectionsByDept(rockEdId);
        } else if (selectedId) {
          dispatch(setCategoryData(response.partners, selectedId));
          fetchCollectionsByDept(selectedId);
        }
      } catch (err) {
        setError(err);
        dispatch(showProgress(false));
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  return {
    fetchPartnerTypes,
    fetchCollectionsByDept,
    error,
  };
};

export default useCategory;
